import React from 'react';
import { PercentileLevel } from '@talentmesh/utils';

import { AnimatedCircularProgressBar } from '@/Components/shadcn/animated-circular-progress-bar';

import ConnectorIcon from './ConnectorIcon';
import isFlipped from './PetalUtils';

export interface RightPetalProps {
    value: number;
    level: PercentileLevel;
    name: string;
    index: number;
    count: number;
}
function RightPetal({ value, level, name, index, count }: RightPetalProps): React.JSX.Element {
    return (
        <div className="grid w-full grid-cols-12 items-center">
            <div className="col-span-3">
                <ConnectorIcon index={index} count={count} isMirrored isFlipped={isFlipped(count, index)} />
            </div>
            <div className="col-span-3 mx-auto">
                <AnimatedCircularProgressBar value={value} level={level} className="size-12 text-base font-semibold" />
            </div>
            <div className="col-span-6">
                <h5 className="text-base font-semibold">{name}</h5>
            </div>
        </div>
    );
}

export default RightPetal;
